import ModalDialog from './modal-dialog';

const selectors = {
  notifyMeBtn: '[data-notify-me-btn]',
  variantOption: '[data-variant-option]',
  klaviyoNotifyMe: '[data-klaviyo-notify-me]',
  klaviyoNotifyForm: '[data-klaviyo-notify-form]',
  notifyFormContainer: '[data-notify-form-container]',
  productName: '[data-product-name]',
};

export function initKlaviyoNotifyMe(container, variant) {
  const variantId = variant.id;

  if (!variantId) return;

  const handleNotifyFormSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const formElements = form.elements;
    const notifyFormContainer = container.querySelector(selectors.notifyFormContainer);
    const notifyFormMessage = notifyFormContainer.querySelector('.notify-messages');

    if (
      !formElements.a.value ||
      !formElements.variant.value ||
      !formElements.platform.value ||
      !formElements.email.value
    ) {
      return;
    }

    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formElements.a.value}`;
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: formElements.email.value,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${formElements.variant.value}`,
            },
          },
        },
      },
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-10-15',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.ok) {
          if (notifyFormMessage.querySelector('.error-message').classList.contains('active')) {
            notifyFormMessage.querySelector('.error-message').classList.remove('active');
          }
          if (notifyFormMessage.querySelector('.empty-message').classList.contains('active')) {
            notifyFormMessage.querySelector('.empty-message').classList.remove('active');
          }
          notifyFormMessage.querySelector('.success-message').classList.add('active');
          notifyFormMessage.classList.add('submitted');
        } else {
          notifyFormMessage.querySelector('.error-message').classList.add('active');
        }
      })
      .catch((err) => {
        window.console.error(err);
      });
  };

  const klaviyoNotifyFormElement = container.querySelector(selectors.klaviyoNotifyForm);
  // Notify Me - Back In Stock
  if (klaviyoNotifyFormElement) {
    // Klaviyo Notify Me - Popup
    const modalContainer = document.querySelector('.product-form__klaviyo.product');
    const modalId = 'klaviyo-notify-me-product';
    const modalEl = modalContainer.querySelector(`#modal-${modalId}`);
    if (!modalEl) return;

    const focusEl = modalEl.querySelector('[data-modal-close]');
    const notifyMeBtnEl = container.querySelectorAll(selectors.notifyMeBtn);
    if (!notifyMeBtnEl || !focusEl) return;

    // eslint-disable-next-line no-unused-vars
    const klaviyoNotifyMeModal = new ModalDialog(modalEl, {
      triggerEl: notifyMeBtnEl,
      modalId,
      focusEl,
    });
    klaviyoNotifyFormElement.addEventListener('submit', handleNotifyFormSubmit.bind(event));

    // Form messages
    const notifyForm = container.querySelector(selectors.klaviyoNotifyForm);
    const notifyMessages = container.querySelector('.notify-messages');
    if (!notifyForm) return;
    const notifyFormElements = notifyForm.elements;
    if (!notifyMessages) return;

    if (notifyMessages.classList.contains('submitted')) {
      notifyMessages.classList.remove('submitted');
      notifyMessages.querySelector('.success-message').classList.remove('active');
      notifyFormElements.email.value = '';
    }
  }
}
